@let isMobile = isMobile$ | async;

<div id="event-panel" [ngClass]="{ column: isMobile }">
	<am-event-navigation></am-event-navigation>
	<router-outlet></router-outlet>
</div>
